import React from 'react'
import Messages from './Messages/Messages'
import RemainingGuesses from './RemainingGuesses/RemainingGuesses'
import styles from './MessageBox.module.css'
import { connect } from 'react-redux'

const MessageBox = props => {
  
  return (
    <section className={styles.Messages}>
      <Messages 
        statusMessage={props.statusMessage}
        gameStatus={props.game.gameStatus}
        numberOfGuesses={props.numberOfGuesses}
        remainingGuesses={props.remainingGuesses}
        alphabet={props.alphabet}
        currentLetter={props.currentLetter}
        correctLettersCount={props.currentNumberOfCorrectLetters}
        show={props.show}
      />  
      <RemainingGuesses 
        remainingGuesses={props.remainingGuesses}
      />
    </section> 
    )
  }
  
  const mapStateToProps = state => {
    return {
      game: state.puzzle.game,
      alphabet: state.puzzle.alphabet,
      currentLetter: state.puzzle.currentLetter,
      numberOfGuesses: state.puzzle.numberOfGuesses,
      statusMessage: state.puzzle.statusMessage,
      remainingGuesses: state.puzzle.game.howManyRemainingGuesses,
      currentNumberOfCorrectLetters: state.puzzle.currentNumberOfCorrectLetters
    }
  }

  export default connect(mapStateToProps)(MessageBox)